"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _UICoreFormValidator_instances, _UICoreFormValidator_importTranslations;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UICoreFormValidator = void 0;
const facile_validator_1 = require("@upjs/facile-validator");
class UICoreFormValidator {
    constructor(config) {
        _UICoreFormValidator_instances.add(this);
        const defaultConfig = Object.assign(Object.assign({}, UICoreFormValidator.config), config);
        const translations = __classPrivateFieldGet(this, _UICoreFormValidator_instances, "m", _UICoreFormValidator_importTranslations).call(this, defaultConfig);
        document.addEventListener('DOMContentLoaded', () => {
            const formElements = document.querySelectorAll('form[data-validation=true]');
            formElements.forEach((form) => {
                const v = new facile_validator_1.Validator(form, {
                    lang: translations[UICoreFormValidator.currentLocale],
                    onFieldChangeValidation: true,
                    on: {
                        'validation:success': () => {
                            form.submit();
                        },
                        'field:error': (container, element, errors) => {
                            errors.forEach((error) => {
                                if (element.hasAttribute('data-message') && error.cause === 'regex') {
                                    error.message = element.getAttribute('data-message');
                                }
                            });
                        },
                    }
                });
                form.addEventListener('submit', (e) => {
                    e.preventDefault();
                    v.validate();
                });
            });
        });
    }
}
exports.UICoreFormValidator = UICoreFormValidator;
_UICoreFormValidator_instances = new WeakSet(), _UICoreFormValidator_importTranslations = function _UICoreFormValidator_importTranslations(defaultConfig) {
    let translations = [];
    Promise.resolve().then(() => __importStar(require('@upjs/facile-validator'))).then((module) => {
        defaultConfig['translations'].forEach((locale) => {
            const localeString = locale.substr(0, 2);
            translations[locale] = module[`${localeString}Lang`];
        });
    });
    return translations;
};
UICoreFormValidator.config = {
    translations: [
        'nl_NL',
    ],
};
UICoreFormValidator.currentLocale = window['Locale'] || 'nl_NL';
